<template>
<el-dialog class='apis-application-dialog' title="申请使用 API 服务" size="small" @close='close' :visible.sync='dialogVisable'>
  <el-form class='application-form' ref='application' label-width="110px">
    <el-form-item label="姓名">
      <el-input v-model="application.name"></el-input>
    </el-form-item>

    <el-form-item label="电话">
      <el-input v-model="application.phone"></el-input>
    </el-form-item>

    <el-form-item label="公司">
      <el-input v-model="application.company"></el-input>
    </el-form-item>

    <el-form-item label="使用场景">
      <el-input v-model="application.scenario" placeholder="如教育课件，市场营销，微信运营等"></el-input>
    </el-form-item>

    <el-form-item label="使用数量">
      <el-input v-model="application.estimate_ppts" placeholder="预计转化数量，可使用描述性文字，如一年两万次转化等"></el-input>
    </el-form-item>
  </el-form>

  <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="sendApplication()">提交表格，并联系我们</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisable: false,
      application: {
        name: null,
        phone: null,
        company: null,
        scenario: null,
        estimate_ppts: null
      }
    }
  },
  methods: {
    open() {
      this.dialogVisable = true
    },
    close() {
      this.dialogVisable = false
    },
    sendApplication() {
      let vm = this
      vm.$store.dispatch('apis/sendApplication', vm.application).then(res => {
        vm.$contactMarket()
        vm.close()
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.apis-application-dialog {
    .application-form {
        margin: 20px 0;
    }

    .dialog-footer {
        width: 100%;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// application.dialog.vue?f035391e